

// ── Commission Structure Page ────────────────────────────────────────────────
import { useState } from 'react';
import { ROLE_COLORS, ROLE_LABELS, ROLE_HIERARCHY } from '../../models/User.js';
import { C } from '../../hooks/useUsers.js';

export function CommissionStructurePage() {
  const [rates, setRates] = useState({
    admin: 10, super_distributor: 7, distributor: 5, subdistributor: 3, retailer: 2, client: 0
  });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved]   = useState(false);

  const handleSave = async () => {
    setSaving(true);
    await new Promise(r => setTimeout(r, 800));
    setSaved(true);
    setSaving(false);
  };

  const roles = ROLE_HIERARCHY.filter(r => r !== 'super_admin');

  return (
    <div style={C.page}>
      <div style={C.header}>
        <h1 style={{ ...C.title, borderLeft: '4px solid #10b981', paddingLeft: '12px' }}>Commission Structure</h1>
      </div>

      {/* Visual flow */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0', marginBottom: '28px', overflowX: 'auto', paddingBottom: '8px' }}>
        {roles.map((role, i) => (
          <div key={role} style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ padding: '12px 18px', borderRadius: '10px', backgroundColor: `${ROLE_COLORS[role]}15`, border: `2px solid ${ROLE_COLORS[role]}`, textAlign: 'center', minWidth: '100px' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: ROLE_COLORS[role] }}>{ROLE_LABELS[role]}</div>
              <div style={{ fontSize: '22px', fontWeight: '800', color: ROLE_COLORS[role], marginTop: '4px' }}>{rates[role]}%</div>
            </div>
            {i < roles.length - 1 && (
              <div style={{ fontSize: '18px', color: '#cbd5e1', padding: '0 6px', flexShrink: 0 }}>→</div>
            )}
          </div>
        ))}
      </div>

      {/* Edit table */}
      <div style={{ maxWidth: '500px' }}>
        <div style={C.card}>
          <div style={{ padding: '18px 24px', borderBottom: '1px solid #f1f5f9', fontWeight: '600', fontSize: '14px' }}>Edit Commission Rates</div>
          <div style={{ padding: '20px 24px' }}>
            {roles.map(role => (
              <div key={role} style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '14px' }}>
                <div style={{ width: '140px', fontSize: '13px', fontWeight: '500', color: ROLE_COLORS[role] }}>{ROLE_LABELS[role]}</div>
                <input
                  type="number" min="0" max="100"
                  style={{ ...C.input, width: '100px', textAlign: 'center', fontWeight: '700', color: ROLE_COLORS[role] }}
                  value={rates[role]}
                  onChange={e => { setRates(prev => ({ ...prev, [role]: Number(e.target.value) })); setSaved(false); }}
                />
                <span style={{ fontSize: '13px', color: '#94a3b8' }}>%</span>
              </div>
            ))}
          </div>
          <div style={{ padding: '14px 24px', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'flex-end', gap: '10px', alignItems: 'center' }}>
            {saved && <span style={{ fontSize: '13px', color: '#10b981' }}>✓ Saved</span>}
            <button style={{ ...C.btn, ...C.btnPrim }} onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : 'Save Changes'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CommissionStructurePage;